import { BreadcrumbLink } from "~/components/Breadcrumbs";
import {
  createContentBlockPage,
  createContentBlockPageLoader,
} from "~/components/ContentBlockPage";

export const handle = {
  breadcrumb: () => (
    <BreadcrumbLink to="/datenschutz">Datenschutz</BreadcrumbLink>
  ),
};

export const loader = createContentBlockPageLoader("/datenschutz");

const Page = createContentBlockPage();

export default Page;
